import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { InlineText } from "../../components/InlineText";

import { ReactComponent as SuccessGif } from "../../assets/svgs/prequal.svg";
import { ReactComponent as ErrorGif } from "../../assets/svgs/not-qualified.svg";
const PreQualificationResult = (props) => {
    const { stepValues } = props;
    let preQualificationOptions = [
        {
            id: "bankruptcies",
            reason: "Someone in your household has a bankruptcy in the last 2 years",
        },
        {
            id: "evictions",
            reason: "Someone in your household has had an eviction in the last 5 years",
        },
        {
            id: "sexOffender",
            reason: "Someone in your household has been convicted as a sex offender",
        },
        {
            id: "ofac",
            reason: "Someone in your household is on the OFAC sanction list",
        },
    ];

    const getResults = () => {
        return preQualificationOptions?.filter((item) => stepValues[item.id].indexOf("Yes") > -1);
    };

    return (
        <Box sx={{ textAlign: "center" }}>
            {getResults()?.length > 0 ? (
                <>
                    <ErrorGif style={{ width: "200px" }}></ErrorGif>
                    <Typography variant="h1" component="h1">
                        Oh no! You don't qualify
                    </Typography>
                    <Typography sx={{ mt: "3rem", textAlign: "left" }} variant="h6">
                        Unfortunately, you do not qualify because...
                    </Typography>
                </>
            ) : (
                <>
                    <SuccessGif style={{ width: "200px" }}></SuccessGif>
                    <Typography variant="h1" component="h1">
                        Yay! You're prequalified!
                    </Typography>
                    <Typography sx={{ mt: "10px" }} variant="h6">
                        {"Let's move on to the application"}
                    </Typography>
                </>
            )}
            {getResults()?.length > 0
                ? preQualificationOptions
                      ?.filter((item) => stepValues[item.id].indexOf("Yes") > -1)
                      ?.map((column) => {
                          return (
                              <InlineText
                                  sx={{ mt: "10px" }}
                                  text={
                                      <Typography variant="h6" component="h6">
                                          {"-    "}
                                          {column.reason}{" "}
                                      </Typography>
                                  }
                              ></InlineText>
                          );
                      })
                : ""}
            {getResults()?.length > 0 ? (
                <Typography sx={{ mt: "3rem" }} variant="h6">
                    <b>
                        Even though you don't qualify, you're still welcome to apply; however, your chances of approval
                        are low.
                    </b>
                </Typography>
            ) : (
                <Typography sx={{ mt: "10px" }} variant="h6">
                    <b>Qualification does not guarantee application approval</b>
                </Typography>
            )}
        </Box>
    );
};

export { PreQualificationResult };
